import Vue from 'vue';

import VueToast from 'vue-toast-notification';

import VueScrollTo from 'vue-scrollto'

import IdleVue from "idle-vue";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import VueMask from 'v-mask';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
dom.watch();
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/js/bootstrap';
import 'vuetify/dist/vuetify.min.css';
import 'vue-toast-notification/dist/theme-default.css';
import 'jquery/dist/jquery';
import '@popperjs/core/dist/umd/popper';
import 'material-icons/iconfont/material-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import VuejsDialog from 'vuejs-dialog';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import Vuetify from 'vuetify';
import pt from "vuetify/lib/locale/pt";

import VueGoogleCharts from 'vue-google-charts'

import './global/css/styles.css';
import './global/css/buttons.css';
import './global/css/text.css';
import './global/css/colors.css';
import './global/css/dashboard.css';
import './global/css/account.css';
import './global/css/font.css';
import './global/css/navbar.css';

import Vue2Editor from "vue2-editor";

import * as VueGoogleMaps from 'vue2-google-maps'

import VueCompositionApi from '@vue/composition-api';

const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: ((10 * 60) * 1000)
});

Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(IconsPlugin);
Vue.use(VuejsDialog);
Vue.use(VueToast);
Vue.use(VueMask);
Vue.use(VueScrollTo);
Vue.use(Vuesax);
Vue.use(VueGoogleCharts);
Vue.use(Vue2Editor);
Vue.use(VueCompositionApi);

import App from './App.vue';

import router from './routes';
import store from './store';
import './registerServiceWorker'

Vue.config.productionTip = false;

new Vue({
    vuetify: new Vuetify({
        icons: {
            iconfont: 'mdi',
        },
        lang: {
            locales: { pt },
            current: "pt",
        },
    }), render: h => h(App), router, store, onIdle() {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("permissions");
    },
}).$mount('#app');

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCk9RFTZt3Qym7EKJbr_d3bDBxjq248Bwc',
        libraries: 'places',
    },
})
